/* eslint-disable @typescript-eslint/no-explicit-any */
import { partnerTemplatesDataUrlSlugs } from "@/templates/software/confluence/templates/confluence-templates-page/src/test-data/test-data";

import {
    assetFragment,
    collectionFragment,
    lightTemplateFragment,
    relatedTemplateFragment
} from "../fragments";
import {
    ITemplatePageLoader,
    parseCategories,
    parseCollection,
    parseTemplate
} from "../get-content-data";

export const ConfluenceTemplatesPageLoader: ITemplatePageLoader = {
    getQueryData: (_, locale: string, after?: string) => {
        return {
            query: `#graphql
            query getFeaturedTemplatesAndCollections($search: ContentPlatformSearchAPIv2Query!) {
                templates: templates(search: $search) {
                    edges {
                        node {
                            oneLinerHeadline
                            ...lightTemplateFragment
                        }
                    }
                     pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
                partnerTemplates: templates(search: { queries: { withLocales: ["${locale}"], where: {
                    fieldNamed: "urlSlug",
                    havingValues:
                        ${JSON.stringify(partnerTemplatesDataUrlSlugs)}
                } }}) {
                    edges {
                        node {
                            oneLinerHeadline
                            ...lightTemplateFragment
                        }
                    }
                }
                templateCollections(search: { queries: { first: 50, withLocales: ["${locale}"] }}) {
                    edges {
                        node {
                            ...collectionFragment

                        }
                    }
                }
                contentFacet(first: 25, forFields: ["category"], forContentType: "Template", withLocales: ["${locale}"]) {
                    edges {
                      node {
                        context
                      }
                    }
                  }
            }
            ${lightTemplateFragment}
            ${collectionFragment}
            ${relatedTemplateFragment}
            ${assetFragment}
            `,
            variables: {
                search: {
                    queries: { first: 200, withLocales: [locale], after }
                }
            }
        };
    },
    parseData: (data: any, locale?: string) => {
        const templates = [];
        const collections = [];
        const partnerTemplates = [];
        const categories = parseCategories(data.contentFacet.edges, locale);

        for (const { node } of data.templates.edges) {
            templates.push(parseTemplate(node));
        }

        for (const { node } of data.partnerTemplates.edges) {
            partnerTemplates.push(parseTemplate(node));
        }

        for (const { node } of data.templateCollections.edges) {
            collections.push(parseCollection(node));
        }

        return {
            templates,
            partnerTemplates,
            collections,
            categories
        };
    },
    multiplePagesQuery: true
};
